import TopoSelfAssistant from '../pages/Topo/TopoSelfAssistant';

function PageWithTopoSelf({ children, assistant, sessionId }) {
  return (
    <>
      <TopoSelfAssistant assistant={assistant} sessionId={sessionId} />
      {children}
    </>
  );
}

export default PageWithTopoSelf;
